module.exports = __webpack_public_path__ + "media/images/font/Gustavo-Bold-f728bcd8f1300f5479ce4f3518218425.svg";